/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGetSafeClientCode } from '@/hooks/router'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { ClientIdentityApiCredsDto, useCreateClientIdentityApi } from '@/gen/publicApi'

import { Button } from '@/components/button'
import { Form } from '@/components/form'
import FormInput from '@/components/form/formInput'
import { useToast } from '@/components/toast/useToast'

interface Props {
    onCreate: (apiKey: ClientIdentityApiCredsDto) => void
}

export default function CreateApiKeyForm({ onCreate }: Props) {
    const clientCode = useGetSafeClientCode()
    const { toast } = useToast()
    const createApiKeyMutator = useCreateClientIdentityApi(clientCode, {
        mutation: {
            onSuccess: onCreate,
            onError: error => {
                // TODO: more specific error handling
                console.error('Error creating API key', error)
                toast({
                    variant: 'destructive',
                    title: 'API key creation failed!',
                    description: `Could not create API key, please try again`,
                })
            },
        },
    })

    const formSchema = z.object({
        name: z.string(),
    })

    const form = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        mode: 'onBlur',
    })

    const onSubmit = (values: z.infer<typeof formSchema>) => {
        createApiKeyMutator.mutate(values)
    }

    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="pt-4 space-y-4">
                <FormInput control={form.control} name="name" label={<>Name</>} />

                <Button type="submit" disabled={!form.formState.isValid || createApiKeyMutator.isPending}>
                    {createApiKeyMutator.isPending ? 'Creating' : 'Create'}
                </Button>
            </form>
        </Form>
    )
}
